export function appBodyClick(){
  return (dispatch) => {
    dispatch({type:'APP_BODY_CLICK'})
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/appAction.js